export const RATING_LIST_ACTION = "RATING_LIST_ACTION";
export const RATING_LIST_SUCCESS = "RATING_LIST_SUCCESS";
export const RATING_APPROVE_ACTION = "RATING_APPROVE_ACTION";
export const RATING_APPROVE_SUCCESS = "RATING_APPROVE_SUCCESS";
export const RATING_DELETE_ACTION = "RATING_DELETE_ACTION";
export const RATING_DELETE_SUCCESS = "RATING_DELETE_SUCCESS";
export const RATING_REPLY_APPROVE_ACTION = "RATING_REPLY_APPROVE_ACTION";
export const RATING_REPLY_APPROVE_SUCCESS = "RATING_REPLY_APPROVE_SUCCESS";
export const RATING_REPLY_DELETE_ACTION = "RATING_REPLY_DELETE_ACTION";
export const RATING_REPLY_DELETE_SUCCESS = "RATING_REPLY_DELETE_SUCCESS";
export const RATING_FAIL = "RATING_FAIL";


